import React,{useState,useRef,useEffect} from "react";
import { createContext } from "react";

export const RoomContextProvider = createContext();

export const WebSocketRoomProvider = ({children})=>{
    const [roomId,setroomId] = useState("hi");
    
    const updateState = (newValue) => {
        setroomId(newValue);
      };
    
      // Provide the state and functions as the context value
    const contextValue = {
        state: roomId,
        updateState: updateState,
      };
    return(
        <WebSocketRoomProvider.Provider value={{roomId,setroomId}}>
            {children}
        </WebSocketRoomProvider.Provider>
    )
}